(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contract-sample-selection"] && !Shopify.designMode) return;
  try {
    
  class ContractSampleSelection extends HTMLElement {
    storageKey = 'stikwood-contract-sample-quantities';
    filterScrollStorageKey = 'stikwood-contract-sample-filter-scroll';
    cartSectionId = 'cart-drawer';

    connectedCallback() {
      this.isCustomerLoggedIn = this.dataset.customerLoggedIn === 'true';
      this.handleClick = this.handleClick.bind(this);
      this.handleFilterLinkClick = this.handleFilterLinkClick.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleExternalCartMutation = this.handleExternalCartMutation.bind(this);
      this.loadNextPage = this.loadNextPage.bind(this);
      this.updateGridColumns = this.updateGridColumns.bind(this);
      this.cartSyncTimers = new Map();
      this.pendingSelections = new Map();
      this.mobileFilterToggle = this.querySelector('[data-contract-sample-filter-toggle]');
      this.mobileFilterToggleText = this.querySelector('[data-contract-sample-filter-toggle-text]');
      this.requestForm = this.querySelector('[data-contract-sample-request-form]');
      this.requestSubmit = this.querySelector('[data-contract-sample-submit]');
      this.handleRequestSubmit = this.handleRequestSubmit.bind(this);
      this.requestStatus = this.querySelector('[data-contract-sample-request-status]');
      this.requestSuccess = this.querySelector('[data-contract-sample-request-success]');
      this.requestEmpty = this.querySelector('[data-contract-sample-empty]');
      this.requestSummaryList = this.querySelector('[data-contract-sample-summary-list]');

      this.addEventListener('click', this.handleClick);
      this.addEventListener('click', this.handleFilterLinkClick, true);
      if (this.requestForm) this.requestForm.addEventListener('submit', this.handleRequestSubmit);
      if (this.isCustomerLoggedIn) {
        document.addEventListener('cart:updated', this.handleCartUpdate);
        document.addEventListener('cart:refresh', this.handleCartUpdate);
        document.addEventListener('contract-sample-cart-mutated', this.handleExternalCartMutation);
        window.addEventListener('focus', this.handleExternalCartMutation);
        window.addEventListener('pageshow', this.handleExternalCartMutation);
      }
      window.addEventListener('resize', this.updateGridColumns);

      if (this.isCustomerLoggedIn) this.setupCartFetchObserver();
      this.restoreFilterScrollPosition();
      if (this.isCustomerLoggedIn) {
        this.syncSelectionsFromCart();
      } else {
        this.restoreSelections();
        this.applyDeepLinkedSample();
        this.updateRequestSummary();
      }
      this.setupLazyLoading();
      this.updateGridColumns();
    }

    disconnectedCallback() {
      if (this.loadObserver) this.loadObserver.disconnect();
      this.removeEventListener('click', this.handleFilterLinkClick, true);
      if (this.requestForm) this.requestForm.removeEventListener('submit', this.handleRequestSubmit);
      document.removeEventListener('cart:updated', this.handleCartUpdate);
      document.removeEventListener('cart:refresh', this.handleCartUpdate);
      document.removeEventListener('contract-sample-cart-mutated', this.handleExternalCartMutation);
      window.removeEventListener('focus', this.handleExternalCartMutation);
      window.removeEventListener('pageshow', this.handleExternalCartMutation);
      window.removeEventListener('resize', this.updateGridColumns);
      if (this.cartRefreshTimer) window.clearTimeout(this.cartRefreshTimer);
      this.cartSyncTimers.forEach((timer) => window.clearTimeout(timer));
      this.cartSyncTimers.clear();
    }

    handleFilterLinkClick(event) {
      const filterLink = event.target.closest(
        '.contract-sample-selection__filter-value[href], .contract-sample-selection__chip[href]'
      );

      if (!filterLink || !this.contains(filterLink) || !window.sessionStorage) return;
      if (filterLink.target && filterLink.target !== '_self') return;
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      window.sessionStorage.setItem(this.filterScrollStorageKey, JSON.stringify(this.getScrollPosition()));
    }

    restoreFilterScrollPosition() {
      if (!window.sessionStorage) return;

      const savedPosition = window.sessionStorage.getItem(this.filterScrollStorageKey);

      if (!savedPosition) return;

      window.sessionStorage.removeItem(this.filterScrollStorageKey);

      try {
        this.restoreScrollPosition(JSON.parse(savedPosition));
      } catch (error) {
        return;
      }
    }

    handleClick(event) {
      const filterToggle = event.target.closest('[data-contract-sample-filter-toggle]');
      if (filterToggle) {
        event.preventDefault();
        this.toggleMobileFilters();
        return;
      }

      const selectButton = event.target.closest('[data-contract-sample-select]');
      const incrementButton = event.target.closest('[data-contract-sample-increment]');
      const decrementButton = event.target.closest('[data-contract-sample-decrement]');

      if (!selectButton && !incrementButton && !decrementButton) return;

      const form = event.target.closest('[data-contract-sample-form]');

      if (!form) return;

      event.preventDefault();

      if (form.dataset.sampleSyncing === 'true') return;

      const currentQuantity = this.getFormQuantity(form);
      let nextQuantity = currentQuantity;

      if (!this.isCustomerLoggedIn && selectButton) {
        nextQuantity = currentQuantity > 0 ? 0 : 1;
      } else {
        if (selectButton && currentQuantity === 0) nextQuantity = 1;
        if (incrementButton) nextQuantity = currentQuantity + 1;
        if (decrementButton) nextQuantity = Math.max(0, currentQuantity - 1);

        if (!this.isCustomerLoggedIn) nextQuantity = nextQuantity > 0 ? 1 : 0;
      }

      this.setFormQuantity(form, nextQuantity);
      this.saveSelection(form, nextQuantity);

      if (this.isCustomerLoggedIn) {
        this.queueCartSync(form, nextQuantity);
      } else {
        this.updateRequestSummary();
      }
    }

    toggleMobileFilters() {
      const isOpen = !this.classList.contains('is-mobile-filter-open');

      this.classList.toggle('is-mobile-filter-open', isOpen);
      if (this.mobileFilterToggle) this.mobileFilterToggle.setAttribute('aria-expanded', String(isOpen));
      if (this.mobileFilterToggleText) this.mobileFilterToggleText.textContent = isOpen ? 'hide filter' : 'show filter';
    }

    setupLazyLoading() {
      this.grid = this.querySelector('[data-contract-sample-grid]');
      this.loadMore = this.querySelector('[data-contract-sample-load-more]');
      this.loadStatus = this.querySelector('[data-contract-sample-load-status]');
      this.loadSentinel = this.querySelector('[data-contract-sample-load-sentinel]');
      this.nextUrl = this.normalizePageUrl(this.loadMore?.dataset.nextUrl || '');
      this.isLoading = false;

      if (!this.grid || !this.loadMore || !this.nextUrl) return;

      this.classList.add('is-lazy-ready');
      this.loadMore.hidden = false;

      if (!('IntersectionObserver' in window) || !this.loadSentinel) return;

      this.loadObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      }, { rootMargin: '600px 0px 600px' });

      this.loadObserver.observe(this.loadSentinel);
    }

    async loadNextPage() {
      if (this.isLoading || !this.nextUrl || !this.grid) return;

      this.isLoading = true;
      this.setLoadingState(true);

      try {
        const response = await fetch(this.nextUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error('Next sample page failed to load.');

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentFragment.querySelector('[data-contract-sample-grid]');
        const nextItems = nextGrid ? [...nextGrid.querySelectorAll('[data-contract-sample-grid-item]')] : [];

        nextItems.forEach((item) => this.grid.appendChild(document.importNode(item, true)));

        const nextLoadMore = documentFragment.querySelector('[data-contract-sample-load-more][data-next-url]');

        this.nextUrl = this.normalizePageUrl(nextLoadMore?.dataset.nextUrl || '');

        if (this.nextUrl) {
          this.loadMore.dataset.nextUrl = this.nextUrl;
        } else {
          this.loadMore.hidden = true;
          delete this.loadMore.dataset.nextUrl;
          if (this.loadObserver) this.loadObserver.disconnect();
        }

        if (this.isCustomerLoggedIn) {
          this.syncSelectionsFromCart();
        } else {
          this.restoreSelections();
          this.applyDeepLinkedSample();
          this.updateRequestSummary();
        }
        this.updateGridColumns();
      } catch (error) {
        this.classList.remove('is-lazy-ready');
        if (this.loadObserver) this.loadObserver.disconnect();
      } finally {
        this.isLoading = false;
        this.setLoadingState(false);
      }
    }

    setLoadingState(isLoading) {
      if (this.loadStatus) this.loadStatus.hidden = !isLoading;
    }

    normalizePageUrl(url) {
      if (!url) return '';

      const nextUrl = new URL(url, window.location.origin);
      const currentUrl = new URL(window.location.href);

      ['v', 'preview_theme_id', 'view'].forEach((parameter) => {
        if (currentUrl.searchParams.has(parameter) && !nextUrl.searchParams.has(parameter)) {
          nextUrl.searchParams.set(parameter, currentUrl.searchParams.get(parameter));
        }
      });

      return nextUrl.toString();
    }

    updateGridColumns() {
      const grid = this.querySelector('[data-contract-sample-grid]');

      if (!grid) return;

      const styles = window.getComputedStyle(grid);
      const columnGap = parseFloat(styles.columnGap) || 0;
      const maxColumnWidth = parseFloat(styles.getPropertyValue('--contract-sample-auto-card-max-width')) || 520;
      const gridWidth = grid.clientWidth;
      let columns = 1;

      if (gridWidth > 0 && maxColumnWidth > 0) {
        columns = Math.ceil((gridWidth + columnGap) / (maxColumnWidth + columnGap));
      }

      grid.style.setProperty('--contract-sample-auto-columns', Math.max(columns, 1));
    }

    restoreSelections() {
      const selections = this.readSelections();

      this.querySelectorAll('[data-contract-sample-form]').forEach((form) => {
        const variantId = this.getVariantId(form);
        let quantity = variantId ? parseInt(selections[variantId], 10) || 0 : 0;

        if (!this.isCustomerLoggedIn) quantity = quantity > 0 ? 1 : 0;

        this.setFormQuantity(form, quantity);
      });
    }

    applyDeepLinkedSample() {
      if (this.isCustomerLoggedIn || this.deepLinkedSampleApplied) return;

      const variantId = new URLSearchParams(window.location.search).get('contract_sample_variant');

      if (!variantId) return;

      const form = [...this.querySelectorAll('[data-contract-sample-form]')]
        .find((sampleForm) => String(this.getVariantId(sampleForm)) === String(variantId));

      if (!form) return;

      this.setFormQuantity(form, 1);
      this.saveSelection(form, 1);
      this.deepLinkedSampleApplied = true;

      const card = form.closest('.contract-sample-card');
      if (card) window.requestAnimationFrame(() => card.scrollIntoView({ block: 'center', behavior: 'smooth' }));
    }

    handleCartUpdate(event) {
      const cart = event.detail?.cart;

      if (cart?.items) {
        this.applyCartSelections(cart, { preserveScroll: true });
      } else {
        this.scheduleCartRefresh({ preserveScroll: true });
      }
    }

    handleExternalCartMutation() {
      this.scheduleCartRefresh({ preserveScroll: true });
    }

    scheduleCartRefresh(options = {}) {
      if (this.cartRefreshTimer) window.clearTimeout(this.cartRefreshTimer);

      this.cartRefreshTimer = window.setTimeout(() => {
        this.syncSelectionsFromCart(options);
      }, 220);
    }

    async syncSelectionsFromCart(options = {}) {
      const scrollPosition = options.preserveScroll ? this.getScrollPosition() : null;

      try {
        const cart = await this.fetchCart();

        this.applyCartSelections(cart);
      } catch (error) {
        this.restoreSelections();
      } finally {
        if (scrollPosition) this.restoreScrollPosition(scrollPosition);
      }
    }

    applyCartSelections(cart, options = {}) {
      const scrollPosition = options.preserveScroll ? this.getScrollPosition() : null;
      const selections = {};

      this.querySelectorAll('[data-contract-sample-form]').forEach((form) => {
        const variantId = this.getVariantId(form);
        const cartItem = cart?.items?.find((item) => String(item.variant_id) === String(variantId));
        const cartQuantity = cartItem ? parseInt(cartItem.quantity, 10) || 0 : 0;
        const quantity = this.pendingSelections.has(variantId)
          ? this.pendingSelections.get(variantId)
          : cartQuantity;

        if (variantId && quantity > 0) selections[variantId] = quantity;
        this.setFormQuantity(form, quantity);
      });

      this.writeSelections(selections);

      if (scrollPosition) this.restoreScrollPosition(scrollPosition);
    }

    getScrollPosition() {
      return {
        x: window.scrollX || window.pageXOffset || 0,
        y: window.scrollY || window.pageYOffset || 0,
      };
    }

    restoreScrollPosition(position) {
      const restore = () => {
        window.scrollTo(position.x, position.y);
      };

      restore();
      window.requestAnimationFrame(restore);
      window.setTimeout(restore, 80);
    }

    getFormQuantity(form) {
      const input = form.querySelector('[data-contract-sample-quantity-input]');

      return input ? parseInt(input.value, 10) || 0 : 0;
    }

    setFormQuantity(form, quantity) {
      const card = form.closest('.contract-sample-card');
      const input = form.querySelector('[data-contract-sample-quantity-input]');
      const value = form.querySelector('[data-contract-sample-quantity]');
      let nextQuantity = Math.max(0, quantity);

      if (!this.isCustomerLoggedIn) nextQuantity = nextQuantity > 0 ? 1 : 0;

      if (!card || !input || !value) return;

      input.value = String(nextQuantity);
      value.textContent = String(nextQuantity);
      card.classList.toggle('is-selected', nextQuantity > 0);
      form.setAttribute('data-sample-quantity', String(nextQuantity));

      if (!this.isCustomerLoggedIn) {
        const selectButton = form.querySelector('[data-contract-sample-select]');
        const productTitle = form.dataset.productTitle || 'sample';

        if (selectButton) {
          selectButton.setAttribute('aria-label', nextQuantity > 0 ? `Remove ${productTitle} sample` : `Select ${productTitle} sample`);
        }
      }
    }

    setFormSyncing(form, isSyncing) {
      const card = form.closest('.contract-sample-card');

      if (!card) return;

      form.dataset.sampleSyncing = isSyncing ? 'true' : 'false';
      card.classList.toggle('is-syncing', isSyncing);
    }

    saveSelection(form, quantity) {
      const variantId = this.getVariantId(form);

      if (!variantId) return;

      const selections = this.readSelections();

      if (quantity > 0) {
        selections[variantId] = quantity;
      } else {
        delete selections[variantId];
      }

      this.writeSelections(selections);
    }

    getVariantId(form) {
      return form.querySelector('[name="variant_id"]')?.value;
    }

    readSelections() {
      try {
        return JSON.parse(window.localStorage.getItem(this.storageKey)) || {};
      } catch (error) {
        return {};
      }
    }

    writeSelections(selections) {
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(selections));
      } catch (error) {
        // Selection persistence is a convenience; interaction still works without storage.
      }
    }

    getSelectedSamples() {
      return [...this.querySelectorAll('[data-contract-sample-form]')]
        .map((form) => {
          const quantity = this.getFormQuantity(form);

          if (quantity <= 0) return null;

          return {
            productTitle: form.dataset.productTitle || 'Sample',
            productHandle: form.dataset.productHandle || '',
            productUrl: form.dataset.productUrl || '',
            variantId: form.dataset.variantId || this.getVariantId(form),
            variantTitle: form.dataset.variantTitle || '',
            variantSku: form.dataset.variantSku || '',
            quantity: this.isCustomerLoggedIn ? quantity : 1,
          };
        })
        .filter(Boolean);
    }

    buildSampleDetails(samples) {
      return samples.map((sample) => {
        const parts = [
          sample.variantTitle && sample.variantTitle !== 'Default Title' ? `variant: ${sample.variantTitle}` : '',
          sample.variantSku ? `SKU: ${sample.variantSku}` : '',
          sample.variantId ? `variant ID: ${sample.variantId}` : '',
          `quantity: ${sample.quantity}`,
          sample.productUrl ? `product: ${sample.productUrl}` : '',
        ].filter(Boolean);

        return `- ${sample.productTitle}${parts.length ? ` | ${parts.join(' | ')}` : ''}`;
      }).join('\n');
    }

    getRequestFormData() {
      if (!this.requestForm) return {};

      const formData = new FormData(this.requestForm);

      return {
        firstName: String(formData.get('firstName') || '').trim(),
        lastName: String(formData.get('lastName') || '').trim(),
        email: String(formData.get('email') || '').trim(),
        company: String(formData.get('company') || '').trim(),
        projectName: String(formData.get('projectName') || '').trim(),
        projectNotes: String(formData.get('projectNotes') || '').trim(),
        shippingAddress: {
          address1: String(formData.get('address1') || '').trim(),
          address2: String(formData.get('address2') || '').trim(),
          city: String(formData.get('city') || '').trim(),
          provinceCode: String(formData.get('provinceCode') || '').trim().toUpperCase(),
          zip: String(formData.get('zip') || '').trim(),
          countryCode: String(formData.get('countryCode') || 'US').trim().toUpperCase() || 'US',
        },
      };
    }

    async handleRequestSubmit(event) {
      event.preventDefault();

      const endpoint = this.requestForm?.dataset.contractSampleEndpoint || '';
      const samples = this.getSelectedSamples();

      if (!endpoint) {
        this.setRequestStatus('Sample requests are not connected yet. Please try again later.', true);
        return;
      }

      if (!samples.length) {
        this.setRequestStatus('Choose at least one sample to submit this request.', true);
        return;
      }

      if (!this.requestForm.checkValidity()) {
        this.requestForm.reportValidity();
        return;
      }

      this.setRequestLoading(true);
      this.setRequestStatus('Submitting sample request...', false);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            customer: this.getRequestFormData(),
            samples,
            pageUrl: window.location.href,
            submittedAt: new Date().toISOString(),
          }),
        });

        const result = await response.json().catch(() => ({}));

        if (!response.ok || result?.ok === false) {
          throw new Error(result?.message || 'Draft order request failed.');
        }

        this.writeSelections({});
        this.restoreSelections();
        this.updateRequestSummary();
        this.requestForm.reset();
        this.showRequestSuccess();
      } catch (error) {
        this.setRequestStatus(error.message || 'Draft order request failed. Please try again.', true);
      } finally {
        this.setRequestLoading(false);
      }
    }

    setRequestLoading(isLoading) {
      if (this.requestSubmit) this.requestSubmit.disabled = isLoading || this.getSelectedSamples().length === 0;
      if (this.requestForm) this.requestForm.classList.toggle('is-submitting', isLoading);
    }

    setRequestStatus(message, isError = false) {
      if (!this.requestStatus) return;

      this.requestStatus.textContent = message;
      this.requestStatus.classList.toggle('is-error', isError);
    }

    showRequestSuccess() {
      const requestPanel = this.querySelector('[data-contract-sample-request]');

      if (requestPanel) requestPanel.classList.add('is-complete');
      if (this.requestForm) this.requestForm.hidden = true;
      if (this.requestSuccess) this.requestSuccess.hidden = false;
    }

    updateRequestSummary() {
      if (this.isCustomerLoggedIn) return;

      const samples = this.getSelectedSamples();
      const hasSamples = samples.length > 0;

      if (this.requestSummaryList) {
        this.requestSummaryList.innerHTML = '';
        samples.forEach((sample) => {
          const item = document.createElement('li');
          const meta = [
            sample.variantTitle && sample.variantTitle !== 'Default Title' ? sample.variantTitle : '',
            sample.variantSku ? `SKU ${sample.variantSku}` : '',
            `Qty ${sample.quantity}`,
          ].filter(Boolean).join(' / ');

          item.className = 'contract-sample-request__item';
          item.textContent = sample.productTitle;

          if (meta) {
            const metaElement = document.createElement('span');
            metaElement.className = 'contract-sample-request__item-meta';
            metaElement.textContent = meta;
            item.appendChild(metaElement);
          }

          this.requestSummaryList.appendChild(item);
        });

        this.requestSummaryList.hidden = !hasSamples;
      }

      if (this.requestEmpty) this.requestEmpty.hidden = hasSamples;
      if (this.requestSubmit) this.requestSubmit.disabled = !hasSamples;
      if (this.requestStatus) {
        this.requestStatus.textContent = hasSamples
          ? `${samples.length} sample${samples.length === 1 ? '' : 's'} selected.`
          : 'Choose at least one sample to submit this request.';
      }
    }

    setupCartFetchObserver() {
      if (window.__contractSampleCartFetchObserver) return;

      const originalFetch = window.fetch;

      if (typeof originalFetch !== 'function') return;

      window.__contractSampleCartFetchObserver = true;
      window.fetch = (...args) => {
        const request = args[0];
        const url = typeof request === 'string' ? request : request?.url || '';
        const watchesCart = /\/cart\/(?:add|change|update|clear)\.js(?:\?|$)/.test(url);

        return originalFetch(...args).then((response) => {
          if (watchesCart) {
            window.setTimeout(() => {
              document.dispatchEvent(new CustomEvent('contract-sample-cart-mutated'));
            }, 0);
          }

          return response;
        });
      };
    }

    queueCartSync(form, quantity) {
      const variantId = this.getVariantId(form);

      if (!variantId) return;

      if (this.cartSyncTimers.has(variantId)) {
        window.clearTimeout(this.cartSyncTimers.get(variantId));
      }

      this.pendingSelections.set(variantId, Math.max(0, parseInt(quantity, 10) || 0));
      const timer = window.setTimeout(() => {
        this.cartSyncTimers.delete(variantId);
        this.syncCartQuantity(form, quantity);
      }, 180);

      this.setFormSyncing(form, true);
      this.cartSyncTimers.set(variantId, timer);
    }

    async syncCartQuantity(form, quantity) {
      const variantId = this.getVariantId(form);
      const nextQuantity = Math.max(0, parseInt(quantity, 10) || 0);
      let didSync = false;

      if (!variantId) return;

      try {
        const cart = await this.fetchCart();
        const cartItem = cart.items.find((item) => String(item.variant_id) === String(variantId));

        if (cartItem) {
          await this.changeCartLine(cartItem.key, nextQuantity);
        } else if (nextQuantity > 0) {
          await this.addCartLine(variantId, nextQuantity);
        }

        didSync = true;
      } catch (error) {
        console.error('Contract sample cart sync failed:', error);
        this.pendingSelections.delete(variantId);
        this.syncSelectionsFromCart({ preserveScroll: true });
      } finally {
        if (didSync) this.pendingSelections.delete(variantId);
        this.setFormSyncing(form, false);
      }
    }

    async fetchCart() {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Cart fetch failed.');

      return response.json();
    }

    async addCartLine(variantId, quantity) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }],
          sections: this.cartSectionId,
        }),
      });

      if (!response.ok) throw new Error('Cart add failed.');

      const data = await response.json();
      const cart = await this.fetchCart();

      this.refreshCartDisplay(cart, data.sections);
    }

    async changeCartLine(lineKey, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
          sections: this.cartSectionId,
        }),
      });

      if (!response.ok) throw new Error('Cart change failed.');

      const data = await response.json();

      this.refreshCartDisplay(data, data.sections);
    }

    refreshCartDisplay(cart, sections) {
      if (sections?.[this.cartSectionId] && window.StikCartDrawer?.renderSection) {
        window.StikCartDrawer.renderSection(sections[this.cartSectionId]);
      }

      this.updateCartBadges(cart);

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    }

    updateCartBadges(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;

      const count = cart.item_count > 99 ? '*' : String(cart.item_count);

      document.querySelectorAll('.thb-item-count, .cart-drawer-count, [data-cart-count]').forEach((badge) => {
        badge.textContent = count;
      });
    }
  }

  if (!customElements.get('contract-sample-selection')) {
    customElements.define('contract-sample-selection', ContractSampleSelection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-gallery"]) return;
  try {
    
(function() {
  var wrapper = document.querySelector('.cus-gallery-yotpo-wrapper');
  var belowFold = document.querySelector('.cus-gallery-below-fold');
  if (!wrapper) return;

  function onYotpoReady() {
    // Update min-height to actual size
    var widget = wrapper.querySelector('.yotpo-pictures-widget');
    if (widget && widget.offsetHeight > 100) {
      wrapper.style.minHeight = widget.offsetHeight + 'px';
    }
    // Reveal the section below
    if (belowFold) {
      belowFold.classList.add('is-visible');
    }
  }

  var observer = new MutationObserver(function() {
    var widget = wrapper.querySelector('.yotpo-pictures-widget');
    if (widget && widget.offsetHeight > 100) {
      observer.disconnect();
      onYotpoReady();
    }
  });
  observer.observe(wrapper, { childList: true, subtree: true, attributes: true });

  // Fallback polling
  var checks = 0;
  var interval = setInterval(function() {
    var widget = wrapper.querySelector('.yotpo-pictures-widget');
    if (widget && widget.offsetHeight > 100) {
      clearInterval(interval);
      onYotpoReady();
    }
    if (++checks > 30) {
      clearInterval(interval);
      // Show below-fold anyway after 15s even if Yotpo fails
      if (belowFold) belowFold.classList.add('is-visible');
    }
  }, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-accordion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => scope.querySelectorAll('[data-product-documents]').forEach((root) => {
    if (root.dataset.documentsReady) return;
    root.dataset.documentsReady = 'true';
    const panel = root.querySelector('.cusPanelProduct');
    const observer = new ResizeObserver(() => { if (panel.style.maxHeight) panel.style.maxHeight = panel.scrollHeight + 'px'; });
    observer.observe(panel.querySelector('.is-flex'));
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stikwood-project-feature')) {
    customElements.define('stikwood-project-feature', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.photos = [...this.querySelectorAll('[data-photo]')];
        this.dialog = this.querySelector('dialog');
        this.rail = this.querySelector('.project-feature__rail');
        if (!this.dialog) return;
        this.photos.forEach(photo => { photo.setAttribute('role', 'button'); photo.setAttribute('aria-haspopup', 'dialog'); });
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-photo]');
          if (photo) { event.preventDefault(); this.open(this.photos.indexOf(photo), photo); }
          const close = event.target.closest('[data-close]');
          if (close) this.close();
          const step = event.target.closest('[data-step]');
          if (step) this.show(this.index + Number(step.dataset.step));
          const scroll = event.target.closest('[data-scroll]');
          if (scroll) this.rail.scrollBy({ left: Number(scroll.dataset.scroll) * this.rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === ' ' && event.target.matches('[data-photo]')) { event.preventDefault(); event.target.click(); }
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
          if (event.key === 'Tab') {
            const buttons = [...this.dialog.querySelectorAll('button:not([hidden])')];
            const first = buttons[0], last = buttons[buttons.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        }, { signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); }, { signal });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); }, { signal });
        const stage = this.querySelector('.project-feature__stage');
        stage.addEventListener('touchstart', event => { this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; }, { passive: true, signal });
        stage.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
          this.touch = null;
        }, { passive: true, signal });
        stage.addEventListener('touchcancel', () => { this.touch = null; }, { passive: true, signal });
        stage.addEventListener('touchmove', event => { if (event.touches.length !== 1) this.touch = null; }, { passive: true, signal });
        this.rail.addEventListener('scroll', () => this.updateRail(), { passive: true, signal });
        this.observer = new ResizeObserver(() => this.updateRail());
        this.observer.observe(this.rail);
        this.updateRail();
      }
      updateRail() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.querySelector('.project-feature__rail-controls').hidden = max < 2;
        this.querySelector('[data-scroll="-1"]').disabled = this.rail.scrollLeft < 2;
        this.querySelector('[data-scroll="1"]').disabled = this.rail.scrollLeft >= max - 2;
      }
      show(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.index];
        const image = new Image();
        image.src = photo.href;
        image.alt = photo.dataset.alt;
        this.querySelector('.project-feature__stage').replaceChildren(image);
        const caption = this.querySelector('.project-feature__viewer-caption');
        caption.textContent = photo.dataset.caption;
        caption.hidden = !photo.dataset.caption;
        this.querySelectorAll('[data-position]').forEach((item, i) => { item.hidden = i !== this.index; });
      }
      open(index, opener) {
        document.querySelectorAll('stikwood-project-feature dialog[open]').forEach(dialog => { if (dialog !== this.dialog) dialog.closest('stikwood-project-feature').close(); });
        this.opener = opener;
        this.show(index);
        if (this.dialog.open) return;
        this.savedOverflow = document.documentElement.style.overflow;
        this.locked = true;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-close]').focus();
      }
      close() {
        this.dialog.close();
        this.restore();
      }
      restore() {
        if (!this.locked) return;
        document.documentElement.style.overflow = this.savedOverflow;
        this.locked = false;
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restore();
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
